module.exports = __webpack_public_path__ + "img/mm_b1_img3.5bee8095.png";